import React from "react"
import axios from "axios";
import { Icon } from 'antd';
import { setup as URI_SETUP } from "../../../../config/api";

const uri_modules = URI_SETUP+"add_contract";
const uri_edit_modules = URI_SETUP+"edit_contract";

class AddContract extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title                 : "NEW CONTRACT",
            hotels                : [],
            module                : [],
            modules_option        : "",
            selected_modules      : [],
            min_selected_modules  : [],
            contract    :{
                        _id: "",
                        name: "",
                        subdomain: "",
                        begindate: "",
                        period: "",
                        brands: "",
                        hotels: "",
                        users: "",
                        extrausers: "",
                        dsn: "",
                        database: "",
                        module: "",
                        username: "",
                        email: "",
                        version: ""
                    },
            user_action           : "new",
            hotel_selected_status : "hide",
            hotel_checked_status  : "hide",
            selected_hotel        : "",
            selected_hotel_name   : "",
            fireExistError        : false,
            fireRequiredError     : false,
            loaded                : "hide",
            show_loading          : "hide",
            show_userdata         : "hide"
        }
    }
    componentWillMount(){
        this.getModules();
        this.checkBusiness();
    }

    componentDidUpdate(prevProps, prevState){
        if(this.state.modules != prevState.modules){
            this.setModulesOption();
        }
    }
    checkBusiness(){
        console.log(this.props.editing_business);
        if (this.props.editing_business != ""){
            this.setState({
                user_action : "edit",
                title : "EDIT CONTRACT",
                show_userdata : 'hide',
                loaded: "hide",
                show_loading : "show"
            })
            this.getContract();
        }else{
            this.setState({
                user_action : "new",
                loaded: "show",
                show_loading : "hide",
                title : "NEW CONTRACT",
                show_userdata : 'show'
            })
        }
    }
    handleModuleChange = (e) => {
        let module = Object.assign({}, this.state.module);
        module[e.target.name] = e.target.value;
        this.setState({module});
    }

    getContract(){
        let self = this;
        var qs = require("qs");

        const businessToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            business_id     : self.props.editing_business
        });
        axios.post(URI_SETUP+"getContract", businessToSent)
                .then(request => { 
                    if(request.data["status"]== "success"){
                        console.log(request.data);
                        var contract = [];
                        
                        var version = 'full';
                        if(request.data["data"][0]["lite"] == true){
                            version = 'lite';
                        }
                        contract.name        = request.data["data"][0]["name"];
                        contract.subdomain   = request.data["data"][0]["subdomain"];
                        contract.version     = version;
                        contract.begindate   = request.data["data"][0]["contract"][0]["begin_date"];
                        contract.period      = request.data["data"][0]["contract"][0]["period"];
                        contract.brands      = request.data["data"][0]["contract"][0]["brands"];
                        contract.hotels      = request.data["data"][0]["contract"][0]["hotels"];
                        contract.users       = request.data["data"][0]["contract"][0]["users"];
                        contract.extrausers  = request.data["data"][0]["contract"][0]["extra_users"];
                        contract.dsn         = request.data["data"][0]["contract"][0]["dsn"][0];
                        contract.database    = request.data["data"][0]["contract"][0]["database"][0];
                        contract.module      = request.data["data"][0]["contract"][0]["module"][0].$oid;
                        contract.username    = "NA";
                        contract.email       = "NA";

                        self.setState({
                            module: contract,
                            loaded: "show",
                            show_loading : "hide"
                        })

                        console.log(contract);
                    }
                })
    }

    getModules(){
        let self = this;
        var qs = require("qs");

        const dataToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token")
        });
        axios.post(URI_SETUP+"getModules", dataToSent)
            .then(request => { 
                this.setState({
                    modules : request.data
                });
            });
    }

    setModulesOption(){
        let self = this;
        var modules_obj =  Object.keys(self.state.modules).map((key, index) => {
            return (<option key={self.state.modules[key]._id} value={self.state.modules[key]._id}>{self.state.modules[key].name}</option>);
            });

        self.setState({
            modules_option : modules_obj
        });
    }

    // On submit
    onSubmitModule(e){
        let self = this;
        e.preventDefault();
        self.setState({
            fireRequiredError: false,
            fireExistError: false
        })

        var qs = require("qs");
        
        const contractToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name        : self.state.module.name,
            subdomain   : self.state.module.subdomain,
            begindate   : self.state.module.begindate,
            period      : self.state.module.period,
            brands      : self.state.module.brands,
            hotels      : self.state.module.hotels,
            users       : self.state.module.users,
            extrausers  : self.state.module.extrausers,
            dsn         : self.state.module.dsn,
            database    : self.state.module.database,
            module      : self.state.module.module,
            usename     : self.state.module.username,
            email       : self.state.module.email,
            version     : self.state.module.version
        });

        if(self.state.user_action=="new"){
            axios.post(uri_modules, contractToSent)
                .then(response => { 
                    if ( response.data["status"] === "success" ){
                        self.props.setUserAddedNotification(true);
                        self.props.activeSection("setup","contracts","","");
                    }else{
                        if(response.data["message"] === "required"){
                            self.setState({
                                fireRequiredError: true,
                                fireExistError: false
                            })
                        }else{
                            self.setState({
                                fireRequiredError: false,
                                fireExistError: true
                            })
                        }
                    }
                })
        }else{
            axios.post(uri_edit_modules+"/"+self.props.editing_business, contractToSent)
            .then(response => { 
                if ( response.data["status"] === "success" ){
                    self.props.setUserEditedNotification(true);
                    self.props.activeSection("setup","contracts","","");
                }else{
                    if(response.data["message"] === "required"){
                        self.setState({
                            fireRequiredError: true,
                            fireExistError: false
                        })
                    }else{
                        self.setState({
                            fireRequiredError: false,
                            fireExistError: true
                        })
                    }
                }
            })
        }
    }    

    render() {
        return (
            <section>
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Configuration</h1>
                        <h2>CONTRACTS</h2>
                    </div>
                    <div className="col-md-3 px-2">     
                    </div>
                </div>
                <div className={"suscription "}> 
                    <div className="box regular col-lg-5 col-md-6">
                        <h3 className="title-roles-h3">{this.state.title}</h3>
                        <div className="scrollable content-role-user">
                           <div className="title-role">
                              <h4>Business</h4>
                           </div> 
                           <Icon className={this.state.show_loading} type="loading" />
                           <span className={"error-login " + (this.state.fireExistError === true ? "" : "hide")}>
                                Subdomain already exists
                            </span>
                           <span className={"error-login " + (this.state.fireRequiredError === true ? "" : "hide")}>
                                All data is required
                            </span>
                           <form className={"inputs-roles "} onSubmit={this.onSubmitModule.bind(this)} >
                                <div className="content-input-user">
                                    <input className="input-role" name="name" placeholder="Business name " value={(this.state.module.name==null)? "": this.state.module.name} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Business name</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="subdomain" placeholder="Subdomain " value={(this.state.module.subdomain==null)? "": this.state.module.subdomain} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Subdomain</label>
                                </div>
                                <div className="content-select business">
                                    <select className="form-control top-form-select select-role " name="version" value={(this.state.module.version==null)? "": this.state.module.version} require onChange={e => this.handleModuleChange(e)} >
                                        <option>Version</option>
                                        <option value="full">Full</option>
                                        <option value="lite">Lite</option>
                                        {/* <option value="demo">Demo</option> */}
                                    </select>
                                </div> 
                                <div className="title-role">
                                    <h4>Expiration date</h4>
                                </div>  
                                <div className="content-input-user">
                                    <input type="date" className="input-role" name="begindate" placeholder="Start date " value={(this.state.module.begindate==null)? "": this.state.module.begindate} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Start date</label>
                                </div> 
                                <div className="content-select business">
                                    <select className="form-control top-form-select select-role " name="period" value={(this.state.module.period==null)? "": this.state.module.period} require onChange={e => this.handleModuleChange(e)} >
                                        <option>Period</option>
                                        <option value="1">1 month</option>
                                        <option value="6">6 months</option>
                                        <option value="12">12 months</option>
                                        <option value="18">18 months</option>
                                        <option value="24">24 months</option>
                                    </select>
                                </div> 
                                <div className="title-role">
                                    <h4>Suscription</h4>
                                </div>  
                                <div className="content-input-user input-small">
                                    <input className="input-role" type="number" min="0" max="500" name="brands" placeholder="Brands " value={(this.state.module.brands==null)? "": this.state.module.brands} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Brands</label>
                                </div> 
                                <div className="content-input-user input-small">
                                    <input className="input-role" type="number" min="0" max="500" name="hotels" placeholder="Hotels " value={(this.state.module.hotels==null)? "": this.state.module.hotels} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Hotels</label>
                                </div> 
                                <div className="content-input-user input-small">
                                    <input className="input-role" type="number" min="0" max="500" name="users" placeholder="Users " value={(this.state.module.users==null)? "": this.state.module.users} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Users</label>
                                </div> 
                                <div className="content-input-user input-small">
                                    <input className="input-role" type="number" min="0" max="500" name="extrausers" placeholder="Extra users " value={(this.state.module.extrausers==null)? "": this.state.module.extrausers} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Extra users</label>
                                </div> 
                                <div className="title-role">
                                    <h4>Connection data</h4>
                                </div>  
                                <div className="content-input-user">
                                    <input className="input-role" name="dsn" placeholder="DSN "  value={(this.state.module.dsn==null)? "": this.state.module.dsn} required onChange={e => this.handleModuleChange(e)} />
                                    <label>DSN</label>
                                </div>   
                                <div className="content-input-user">
                                    <input className="input-role" name="database" placeholder="Database " value={(this.state.module.database==null)? "": this.state.module.database} required onChange={e => this.handleModuleChange(e)} />
                                    <label>Database</label>
                                </div>   
                                <div className="title-role">
                                    <h4>Module</h4>
                                </div> 
                                <div className="content-select business">
                                    <select className="form-control top-form-select select-role " name="module" value={(this.state.module.module==null)? "": this.state.module.module} required onChange={e => this.handleModuleChange(e)}  >
                                        <option>Select one</option>
                                        { this.state.modules_option }
                                    </select>
                                </div> 
                                <div className={"content-input-user " + this.state.show_userdata }>
                                    <input className="input-role" name="username" placeholder="User name "  value={(this.state.module.username==null)? "": this.state.module.username} required onChange={e => this.handleModuleChange(e)} />
                                    <label>User name</label>
                                </div>   
                                <div className={"content-input-user " + this.state.show_userdata }>
                                    <input className="input-role" name="email" placeholder="E-mail " value={(this.state.module.email==null)? "": this.state.module.email} required onChange={e => this.handleModuleChange(e)} />
                                    <label>E-mail</label>
                                </div>    
                                <div className="content-select">
                                    <div className="buttons-user">
                                        <button onClick={this.props.activeSection.bind(this,"setup","contracts","","")}>Cancel</button>
                                        <button className="btn-primary" type="submit">Save</button>
                                    </div>
                             </div>      
                           </form>     
                         </div>       
                    </div> 
                </div>           
            </section>
        )
    }
}

export default AddContract


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/AddContract.js